<!--
 * @Author: zb
 * @LastEditors: l_hc
 * @Date: 2019-08-08 19:37:56
 * @LastEditTime: 2019-10-18 18:31:58
 * @Version: 1.0
 * @Description: 编辑、发布货源的页面
 * @Company: 济南广域软件
 * @Copyright: Copyright (c) Jnwat Soft
 * @Remarks: 备注
 -->

<template>
  <div ref="top" v-loading="viewManager.loading" class="publish-goods-container">
    <div class="publish-goods-header">
      <template v-if="viewManager.isEdit">
        <div class="publish-goods-header-title active">编辑货源</div>
      </template>
      <template v-else>
        <section>
          <div
            class="publish-goods-header-title"
            :class="{'active': !Boolean(viewManager.state)}"
            @click="toggleState(0)"
          >保存货源</div>
          <div
            class="publish-goods-header-title"
            :class="{'active': Boolean(viewManager.state)}"
            @click="toggleState(1)"
          >发布货源</div>
        </section>
      </template>
    </div>
    <div :loading="viewManager.loading" class="publish-goods-body">
      <el-form
        v-if="Boolean(viewManager.state)"
        ref="goodsForm"
        :model="data.formModal"
        :rules="config.requiredRules"
        label-position="right"
        label-width="7rem"
      >
        <el-form-item label="货物类型" prop="goodsType" required>
          <el-radio-group v-model="data.formModal.goodsType">
            <el-radio
              v-for="item of data.goodsType"
              :key="item.id"
              :label="item.value"
            >{{ item.label }}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item v-inputFilter label="货物名称" prop="goodsName" required>
              <el-input v-model="data.formModal.goodsName" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="理化性质" prop="physicalProperty" required>
              <physical-property v-model="data.formModal.physicalProperty" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="包装类型" prop="packageType" required>
              <el-select v-model="data.formModal.packageType">
                <el-option
                  v-for="item of data.packageType"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="运输方式" prop="transportType" required>
              <el-select v-model="data.formModal.transportType" multiple>
                <el-option
                  v-for="item of data.transportType"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="付款方式" prop="payType" required>
              <el-select v-model="data.formModal.payType">
                <el-option
                  v-for="item of data.payType"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item v-inputFilter label="报价截止时间" prop="expireDate" required>
              <el-date-picker
                v-model="data.formModal.expireDate"
                :editable="false"
                type="date"
                :picker-options="data.expirePickerOptions"
                placeholder="报价截止时间"
              />
            </el-form-item>
            <!-- <el-form-item label="货物体积" prop="capacity">
              <el-input v-model="data.formModal.capacity">
                <span slot="suffix">m³</span>
              </el-input>
            </el-form-item>-->
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="货物重量" prop="weight" required>
              <el-input v-model="data.formModal.weight">
                <span slot="suffix">吨</span>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="出价方式" prop="buyType">
              <el-radio-group v-model="data.formModal.buyType">
                <el-radio :label="0">报价</el-radio>
                <el-radio :label="1">计算</el-radio>
              </el-radio-group>
              <span
                v-if="data.formModal.buyType"
                style="color: red margin-left: 8pxfont-size: 12px"
              >总价格 = 单价 * 货物重量 * 距离</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="12">
            <el-form-item label="单价" prop="singlePrice">
              <el-input v-model="data.formModal.singlePrice">
                <span slot="suffix">元/吨公里</span>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col v-show="data.formModal.buyType == 1" :span="6">
            <el-form-item label="距离" prop="distance">
              <el-input v-model="data.formModal.distance">
                <span slot="suffix">公里</span>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="(data.formModal.buyType == 1) ? 6:12">
            <el-form-item label="总价格" :prop="(data.formModal.buyType == 0)?'expectPrice':''">
              <el-input
                v-model="data.formModal.expectPrice"
                :readonly="data.formModal.buyType == 1"
              >
                <span slot="suffix">元</span>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="起运日期" prop="startTransportDate" required>
              <el-date-picker
                v-model="data.formModal.startTransportDate"
                :editable="false"
                type="date"
                :picker-options="data.startPickerOptions"
                placeholder="选择日期时间"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="到达日期" prop="mostLateDeliveryDate" required>
              <el-date-picker
                v-model="data.formModal.mostLateDeliveryDate"
                :editable="false"
                type="date"
                :picker-options="data.endPickerOptions"
                placeholder="选择日期时间"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="起运地" prop="startPlace" required>
              <el-cascader
                ref="startPlace"
                v-model="data.formModal.startPlace"
                :filterable="true"
                :options="data.area"
                :props="{ expandTrigger: 'hover'}"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="详细地址" prop="startPlaceDetail">
              <el-autocomplete
                v-model="data.formModal.startPlaceDetail"
                :fetch-suggestions="querySearchAsync"
                placeholder="请输入详细地址"
                style="width: 100%;"
              >
                <template slot-scope="{ item }">
                  <div class="name">{{ item.value }}</div>
                  <!--<span class="addr">{{ item.address }}</span>-->
                </template>
              </el-autocomplete>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="目的地" prop="stopPlace" required>
              <el-cascader
                ref="stopPlace"
                v-model="data.formModal.stopPlace"
                :options="data.area"
                :filterable="true"
                :props="{ expandTrigger: 'hover'}"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="详细地址" prop="stopPlaceDetail">
              <el-autocomplete
                v-model="data.formModal.stopPlaceDetail"
                :fetch-suggestions="querySearchAsync"
                placeholder="请输入详细地址"
                style="width: 100%;"
              >
                <template slot-scope="{ item }">
                  <div class="name">{{ item.value }}</div>
                  <!--<span class="addr">{{ item.address }}</span>-->
                </template>
              </el-autocomplete>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item v-inputFilter label="联系人" prop="contacter" required>
              <el-input v-model="data.formModal.contacter" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item v-inputFilter label="联系电话" prop="contacterTel" required>
              <el-input v-model="data.formModal.contacterTel" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-form-item label="货物照片" class="upload-container" prop="fileUrl">
            请上传不大于5M，jpg,png类型图片
            <g-upload
              v-if="!viewManager.loading"
              method-name="goodsFile"
              :multiple="updataMultiple"
              :img-list.sync="data.formModal.fileUrl"
              :max-size="5"
              @update:imgList="deleteImgCallBack"
            />
          </el-form-item>
        </el-row>
        <el-form-item label="备注信息" prop="remarks">
          <el-input v-model="data.formModal.remarks" type="textarea" />
        </el-form-item>
      </el-form>
      <el-form
        v-else-if="viewManager.isEdit || !Boolean(viewManager.state)"
        ref="goodsForm"
        :model="data.formModal"
        :rules="config.rules"
        label-position="right"
        label-width="7rem"
      >
        <el-form-item label="货物类型" prop="goodsType">
          <el-radio-group v-model="data.formModal.goodsType">
            <el-radio
              v-for="item of data.goodsType"
              :key="item.id"
              :label="item.value"
            >{{ item.label }}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item v-inputFilter label="货物名称" prop="goodsName">
              <el-input v-model="data.formModal.goodsName" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="理化性质" prop="physicalProperty">
              <physical-property v-model="data.formModal.physicalProperty" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="包装类型" prop="packageType">
              <el-select v-model="data.formModal.packageType">
                <el-option
                  v-for="item of data.packageType"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="运输方式" prop="transportType">
              <el-select v-model="data.formModal.transportType" multiple>
                <el-option
                  v-for="item of data.transportType"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="付款方式" prop="payType">
              <el-select v-model="data.formModal.payType">
                <el-option
                  v-for="item of data.payType"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item v-inputFilter label="报价截止时间" prop="expireDate">
              <el-date-picker
                v-model="data.formModal.expireDate"
                :editable="false"
                type="date"
                :picker-options="data.expirePickerOptions"
                placeholder="报价截止时间"
              />
            </el-form-item>
            <!-- <el-form-item label="货物体积" prop="capacity">
              <el-input v-model="data.formModal.capacity">
                <span slot="suffix">m³</span>
              </el-input>
            </el-form-item>-->
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="货物重量" prop="weight">
              <el-input v-model="data.formModal.weight">
                <span slot="suffix">吨</span>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="出价方式" prop="buyType">
              <el-radio-group v-model="data.formModal.buyType">
                <el-radio :label="0">报价</el-radio>
                <el-radio :label="1">计算</el-radio>
              </el-radio-group>
              <span
                v-if="data.formModal.buyType"
                style="color: red margin-left: 8px font-size: 12px"
              >总价格 = 单价 * 货物重量 * 距离</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="12">
            <el-form-item label="单价" prop="singlePrice">
              <el-input v-model="data.formModal.singlePrice">
                <span slot="suffix">元/吨公里</span>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col v-show="data.formModal.buyType == 1" :span="6">
            <el-form-item label="距离" prop="distance">
              <el-input v-model="data.formModal.distance">
                <span slot="suffix">公里</span>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="(data.formModal.buyType == 1) ? 6:12">
            <el-form-item label="总价格" :prop="(data.formModal.buyType == 0)?'expectPrice':''">
              <el-input
                v-model="data.formModal.expectPrice"
                :readonly="data.formModal.buyType == 1"
              >
                <span slot="suffix">元</span>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="起运日期" prop="startTransportDate">
              <el-date-picker
                v-model="data.formModal.startTransportDate"
                :editable="false"
                type="date"
                :picker-options="data.startPickerOptions"
                placeholder="选择日期时间"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="到达日期" prop="mostLateDeliveryDate" require>
              <el-date-picker
                v-model="data.formModal.mostLateDeliveryDate"
                :editable="false"
                type="date"
                :picker-options="data.endPickerOptions"
                placeholder="选择日期时间"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="起运地" prop="startPlace">
              <el-cascader
                ref="startPlace"
                v-model="data.formModal.startPlace"
                :options="data.area"
                :props="{ expandTrigger: 'hover'}"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="详细地址" prop="startPlaceDetail">
              <el-autocomplete
                v-model="data.formModal.startPlaceDetail"
                :fetch-suggestions="querySearchAsync"
                placeholder="请输入详细地址"
                style="width: 100%;"
              >
                <template slot-scope="{ item }">
                  <div class="name">{{ item.value }}</div>
                  <!--<span class="addr">{{ item.address }}</span>-->
                </template>
              </el-autocomplete>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="目的地" prop="stopPlace">
              <el-cascader
                ref="stopPlace"
                v-model="data.formModal.stopPlace"
                :options="data.area"
                :props="{ expandTrigger: 'hover'}"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="详细地址" prop="stopPlaceDetail">
              <el-autocomplete
                v-model="data.formModal.stopPlaceDetail"
                :fetch-suggestions="querySearchAsync"
                placeholder="请输入详细地址"
                style="width: 100%;"
              >
                <template slot-scope="{ item }">
                  <div class="name">{{ item.value }}</div>
                  <!--<span class="addr">{{ item.address }}</span>-->
                </template>
              </el-autocomplete>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item v-inputFilter label="联系人" prop="contacter">
              <el-input v-model="data.formModal.contacter" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item v-inputFilter label="联系电话" prop="contacterTel">
              <el-input v-model="data.formModal.contacterTel" />
            </el-form-item>
          </el-col>
        </el-row>
        <!-- <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item v-inputFilter label="报价截止时间" prop="expireDate">
              <el-date-picker
                v-model="data.formModal.expireDate"
                type="date"
                :editable="false"
                :picker-options="data.expirePickerOptions"
                placeholder="报价截止时间"
              />
            </el-form-item>
          </el-col>
        </el-row>-->
        <el-row>
          <el-form-item label="货物照片" class="upload-container" prop="fileUrl">
            请上传不大于5M，jpg,png类型图片
            <g-upload
              v-if="!viewManager.loading"
              method-name="goodsFile"
              :multiple="updataMultiple"
              :max-size="5"
              :img-list.sync="data.formModal.fileUrl"
              @update:imgList="deleteImgCallBack"
            />
          </el-form-item>
        </el-row>
        <el-form-item label="备注信息" prop="remarks">
          <el-input v-model="data.formModal.remarks" type="textarea" />
        </el-form-item>
      </el-form>
    </div>
    <div class="publish-goods-footer">
      <el-button
        v-if="!viewManager.isEdit && !Boolean(viewManager.state)"
        type="danger"
        plain
        size="small"
        @click="save()"
      >保存</el-button>
      <el-button
        v-if="!viewManager.isEdit && Boolean(viewManager.state)"
        type="danger"
        size="small"
        @click="save()"
      >发布</el-button>
      <el-button v-if="viewManager.isEdit" type="danger" size="small" @click="edit()">提交</el-button>
      <el-button size="small" @click="reset">重置</el-button>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { save, getDetails } from '@/api/personal/find/goodsManager'
import physicalProperty from '@/views/personal/goods/components/physicalProperty'
import { rules, requiredRules } from '../dataConfig/index'
import mixinsFunction from '@/utils/mixinsFunction'
import AMap from 'AMap'
import { multiply } from '@/utils/bigNumber'

const State = {
  Save: 0,
  Publish: 1
}

export default {
  name: 'PublishGoods',
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.detificateSuccess().then(() => {})
    })
  },
  beforeRouteUpdate(to, from, next) {
    this.detificateSuccess().then(() => {
      next()
    })
  },
  components: {
    physicalProperty
  },
  mixins: [mixinsFunction],
  data: function() {
    return {
      updataMultiple: false,
      data: {
        initState: true,
        expirePickerOptions: {
          disabledDate: time => {
            return time.getTime() < new Date().getTime()
          }
        },
        endPickerOptions: {
          disabledDate: time => {
            const beginDateVal = this.data.formModal.startTransportDate
            if (beginDateVal) {
              return time.getTime() <= beginDateVal.getTime()
            } else {
              return (
                time.getTime() < new Date().getTime() - 1000 * 60 * 60 * 24
              )
            }
          }
        },
        startPickerOptions: {
          disabledDate: time => {
            let state =
              time.getTime() < new Date().getTime() - 1000 * 60 * 60 * 24
            if (state) {
              return state
            }
            const endDateVal = this.data.formModal.mostLateDeliveryDate
            if (endDateVal) {
              state = time.getTime() > endDateVal.getTime()
            }
            return state
          }
        },
        // 多级联动地址数据
        area: [],
        // 货物类型
        goodsType: [],
        // 包装类型
        packageType: [],
        // 运输方式
        transportType: [],
        // 付款方式
        payType: [],
        // 货源实体属性
        formModal: {
          expireDate: '',
          contacter: '',
          startPlace: [],
          startPlaceDetail: '',
          stopPlace: [],
          stopPlaceDetail: '',
          goodsType: '1',
          startTransportDate: '',
          mostLateDeliveryDate: '',
          goodsLittleType: '',
          companyId: '',
          // capacity: null,
          weight: null,
          fileUrl: '',
          goodsName: '',
          email: '',
          physicalProperty: '',
          transportTimeliness: '',
          contacterTel: '',
          sendStatus: 1,
          payType: '',
          remarks: '',
          expectPrice: null,
          buyType: 0, // 临时变量, 控制货源出价的方式
          singlePrice: null, // 临时变量, 计算出价货源时， 货源的单价的绑定
          distance: null // 临时变量, 计算出价货源时， 货源的距离的绑定
        }
      },
      config: {
        // 表单的校验规则
        rules: rules,
        requiredRules: requiredRules
      },
      viewManager: {
        visible: false, // 是否显示
        loading: true, // 是否加载
        isEdit: false, //  是否是编辑状态
        state: State.Save,
        close: () => {
          // 关闭
          this.viewManager.visible = false
          this.$emit('close', false)
        }
      }
    }
  },
  watch: {
    // 监听组件内部data属性的改变
    'data.formModal.buyType': {
      handler(newValue, oldValue) {
        if (this.viewManager.isEdit && this.data.initState) {
          return false
        }
        // 计算价格
        if (newValue) {
          this.data.formModal.expectPrice = this.computeTotal()
        } else if (oldValue) {
          this.data.formModal.distance = ''
          // this.data.formModal.singlePrice = ''
          this.data.formModal.expectPrice = ''
        }
      }
    },
    'data.formModal.singlePrice': {
      handler(newValue, oldValue) {
        if (this.viewManager.isEdit && this.data.initState) {
          return false
        }
        if (newValue != oldValue) {
          this.data.formModal.expectPrice =
            this.computeTotal() || this.data.formModal.expectPrice
        }
      }
    },
    'data.formModal.weight': {
      handler(newValue, oldValue) {
        if (this.viewManager.isEdit && this.data.initState) {
          return false
        }
        if (this.data.formModal.buyType && newValue != oldValue) {
          this.data.formModal.expectPrice =
            this.computeTotal() || this.data.formModal.expectPrice
        }
      }
    },
    'data.formModal.distance': {
      handler(newValue, oldValue) {
        if (this.viewManager.isEdit && this.data.initState) {
          return false
        }
        if (newValue != oldValue) {
          this.data.formModal.expectPrice =
            this.computeTotal() || this.data.formModal.expectPrice
        }
      }
    },
    $route: {
      handler: function() {
        const id = this.$route.query.goodsId
        if (!id) {
          this.viewManager.isEdit = false
        } else {
          this.viewManager.isEdit = true
        }
        // 刷新数据
        this.cleanModal(this.data.formModal)
      }
    }
  },
  created: async function() {
    await this.init()
    this.initData()
  },
  methods: {
    // 删除图片成功后的回调
    deleteImgCallBack(imgs) {
      this.data.formModal.fileUrl = imgs
    },
    // 把浮点数转为整数， 返回的数组第一个为10的指数， 第二个为转换后的整数
    decimalToInt(number) {
      if (number) {
        const b = String(number).indexOf('.', 1)
        if (b == -1) {
          return [0, number]
        } else {
          number = String(number).replace('.', '')
          return [parseInt(number.length) - parseInt(b), number]
        }
      } else {
        return [0, 0]
      }
    },
    // 计算总价格
    computeTotal() {
      const resultWeight = this.decimalToInt(this.data.formModal.weight)
      const resultDistance = this.decimalToInt(this.data.formModal.distance)
      const resultSinglePrice = this.decimalToInt(
        this.data.formModal.singlePrice
      )
      const r = multiply(
        multiply(resultWeight[1], resultDistance[1]),
        resultSinglePrice[1]
      )
      const offsetRight =
        resultWeight[0] + resultDistance[0] + resultSinglePrice[0]
      if (offsetRight > 0 && r != '0' && r.length > offsetRight) {
        const childL = r.substring(0, r.length - offsetRight)
        const childR = r.substring(childL.length).replace(/0/g, '')
        if (childR.length == 0) {
          return childL
        } else {
          return childL + '.' + childR
        }
      }
      return r
    },
    initData() {
      // this.data.formModal.contacter = this.userInfo.realName
      // this.data.formModal.contacterTel = this.userInfo.phone
      Vue.set(this.data.formModal, 'buyType', 0)
      // this.data.formModal.buyType = 0
    },
    toggleState(state) {
      this.viewManager.state = state
      this.reset()
      this.initData()
      this.$nextTick(() => {
        this.$refs['goodsForm'].clearValidate()
      })
    },
    querySearchAsync(query, cb) {
      let address
      if (query === this.data.formModal.startPlaceDetail) {
        if (
          this.data.formModal.startPlace &&
          this.data.formModal.startPlace.length > 0
        ) {
          address = this.data.formModal.startPlace
        } else {
          this.$message({
            message: '请先选择起始地!',
            offset: 100,
            type: 'warning'
          })
          this.$refs['startPlace'].$children[0].$el.children[0].focus()
          cb([])
        }
      } else if (query === this.data.formModal.stopPlaceDetail) {
        if (
          this.data.formModal.stopPlace &&
          this.data.formModal.stopPlace.length > 0
        ) {
          address = this.data.formModal.stopPlace
        } else {
          this.$message({
            message: '请先选择目的地!',
            offset: 100,
            type: 'warning'
          })
          this.$refs['stopPlace'].$children[0].$el.children[0].focus()
          cb([])
        }
      }
      const results = []
      if (!query) {
        cb(results)
        return false
      }
      AMap.service(['AMap.PlaceSearch'], () => {
        // 构造地点查询类
        const placeSearch = new AMap.PlaceSearch({
          pageSize: 5, // 单页显示结果条数
          pageIndex: 1, // 页码
          city: address[address.length - 1],
          citylimit: true // 是否强制限制在设置的城市内搜索
        })
        // 关键字查询
        placeSearch.search(query, (status, result) => {
          if (status == 'complete') {
            result.poiList.pois.forEach(element => {
              results.push({
                title: element.name,
                value: element.address + element.name,
                address: element.name,
                location: element.location
              })
            })
            cb(results)
          }
        })
      })
    },
    //  初始化理化性质模板数据
    async init() {
      // 通过路由获取要编辑货源的id
      const id = this.$route.query.goodsId
      if (id && id !== '') {
        // 如果货源ID不为空时，就是编辑货源， 把编辑状态设置为true
        this.viewManager.isEdit = true
        await Promise.all([
          this.getGoods(id),
          this.getArea(),
          this.getGoodsType(),
          this.getPackageType(),
          this.getTransportType(),
          this.getPayType()
        ]).then(data => {
          // [
          //   this.data.formModal,
          //   this.data.area,
          //   this.data.goodsType,
          //   this.data.packageType,
          //   this.data.transportType,
          //   this.data.payType
          // ] = data
          console.log(data)
          const formModal = data[0]
          this.data.area = data[1]
          this.data.goodsType = data[2]
          this.data.packageType = data[3]
          this.data.transportType = data[4]
          this.data.payType = data[5]
          formModal.transportType = formModal.transportType.split(',')
          this.data.formModal = formModal
          console.log(874, this.data.formModal)
          if (this.data.formModal.startTransportDate) {
            this.data.formModal.startTransportDate = new Date(
              Date.parse(
                this.data.formModal.startTransportDate.replace(/-/g, '/')
              )
            )
          }
          if (this.data.formModal.mostLateDeliveryDate) {
            this.data.formModal.mostLateDeliveryDate = new Date(
              Date.parse(
                this.data.formModal.mostLateDeliveryDate.replace(/-/g, '/')
              )
            )
          }
        })
      } else {
        await Promise.all([
          this.getArea(),
          this.getGoodsType(),
          this.getPackageType(),
          this.getTransportType(),
          this.getPayType()
        ]).then(data => {
          [
            this.data.area,
            this.data.goodsType,
            this.data.packageType,
            this.data.transportType,
            this.data.payType
          ] = data
        })
      }
      this.viewManager.loading = false
      this.data.initState = false
    },
    //  获取货源详情
    getGoods(id) {
      return getDetails(id)
        .then(data => {
          return this.parseData(data.result)
        })
        .catch(e => {
          console.error(e)
        })
    },
    // 编辑数据
    edit() {
      this.$refs['goodsForm'].validate(valid => {
        if (valid) {
          this.viewManager.loading = true
          const data = this.deleteFormData(
            this.exchangeData(this.data.formModal)
          )
          save(data)
            .then(data => {
              this.$notify({
                title: '成功',
                message: '货源编辑成功',
                type: 'success'
              })
              this.$router.push('./goods-list')
            })
            .catch(e => {
              this.$notify({
                title: '失败',
                message: '货源编辑失败',
                type: 'error'
              })
            })
            .finally(() => {
              this.viewManager.loading = false
            })
        } else {
          this.$nextTick(() => {
            const error = document.querySelector('.is-error input')
            if (error) {
              error.focus()
            }
          })
          return false
        }
      })
    },
    // 保存货源信息
    save() {
      this.data.formModal.sendStatus = this.viewManager.state
      this.$refs['goodsForm'].validate(valid => {
        if (valid) {
          const state = this.viewManager.state ? '发布' : '保存'
          const data = this.deleteFormData(
            this.exchangeData(this.data.formModal)
          )
          // console.log(data)
          var startP = this.data.formModal.startPlace + this.data.formModal.startPlaceDetail
          var stopP = this.data.formModal.stopPlace + this.data.formModal.stopPlaceDetail
          startP = startP.replace(/\s+/g, '')
          stopP = stopP.replace(/\s+/g, '')
          if (startP === stopP) {
            this.$message({
              message: '起运地和目的地重复',
              type: 'warning'
            })
            return
          } else {
            this.viewManager.loading = true
            save(data)
              .then(data => {
                this.$notify({
                  title: '成功',
                  message: `货源${state}成功`,
                  type: 'success'
                })
                this.$router.push('./goods-list')
              })
              .catch(() => {})
              .finally(complete => {
                this.viewManager.loading = false
              })
          }
        } else {
          this.$nextTick(() => {
            const error = document.querySelector('.is-error input')
            if (error) {
              error.focus()
            }
          })
          return false
        }
      })
    },
    deleteFormData(data) {
      if (data.buyType) {
        delete data.buyType
      }
      // if (data.singlePrice) {
      //   delete data.singlePrice
      // }
      if (data.distance) {
        delete data.distance
      }
      return data
    },
    // 重置表单
    reset() {
      this.cleanModal(this.data.formModal)
      this.data.formModal.goodsType = '1'
      this.data.formModal.startTransportDate = ''
      this.data.formModal.buyType = 0
      this.data.formModal.sendStatus = 1
      this.initData()
    },
    // 图片超过3张时的操作事件
    fileOver() {
      this.$message({
        message: '上传图片不能超过3张',
        type: 'warning'
      })
    }
  }
}
</script>

<style lang='scss' scoped>
$prefix: "publish-goods";

.#{$prefix}-container {
  padding: 14px 14px;
  border: 1px solid #dbdbdb;
  background: rgba(255, 255, 255, 1);
  border: 1px solid rgba(221, 221, 221, 1);
  box-sizing: border-box;
  .#{$prefix}-header {
    height: 47px;
    border-bottom: 1px solid #dbdbdb;
    .#{$prefix}-header-title {
      height: calc(100%);
      display: inline-block;
      line-height: 48px;
      // margin: 4px 12px
      min-width: 120px;
      font-weight: bold;
      font-size: 16px;
      border-bottom: 1px solid rgba(32, 27, 27, 0);
      text-align: center;
      cursor: pointer;
      &.active {
        color: #be2316;
        border-bottom: 1px solid #be2316 !important;
      }
    }
  }
  .#{$prefix}-body {
    padding-top: 16px;
  }
  .#{$prefix}-footer {
    // padding-top: 16px
    text-align: center;
    button {
      border-radius: 0px !important;
    }
  }
}

.el-select,
.el-cascader {
  width: 100% !important;
}

/deep/ .el-input__inner,
/deep/ .el-textarea__inner {
  border-radius: 0px !important;
}

/deep/ .el-date-editor.el-input {
  width: 100% !important;
}

.intenal-box {
  width: 100%;
  height: 100%;
  padding: 50px 0px;

  .upload-info-text {
    margin: auto auto;
    width: 100%;
    line-height: 24px;
  }

  .upload-icon {
    margin: auto auto;
    width: 100%;
    line-height: 24px;
  }
}
/deep/ .el-form-item__error {
  z-index: 1000;
}
/deep/ .el-form-item{
  margin-bottom: 29px
}
</style>

